var _linearGradient, _radialGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 36 528 456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.003%",
    x2: "50.003%",
    y1: "1.385%",
    y2: "101.042%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0.02
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "3.407%",
    cy: "2.344%",
    gradientTransform: "matrix(.86364 0 0 1 .005 0)",
    r: "477.746%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 84h432v360H48z",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 276c14.9 0 27-12.1 27-27s-12.1-27-27-27-27 12.1-27 27 12.1 27 27 27zm0 18c-28.9 0-60 15.3-60 34.3V348h120v-19.7c0-19-31.1-34.3-60-34.3zm-192-18c14.9 0 27-12.1 27-27s-12.1-27-27-27-27 12.1-27 27 12.1 27 27 27zm0 18c-28.9 0-60 15.3-60 34.3V348h120v-19.7c0-19-31.1-34.3-60-34.3z",
    fill: "#57bb8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 252c19.9 0 36-16.1 36-36s-16.1-36-36-36-36 16.1-36 36 16.1 36 36 36zm0 24c-40.5 0-84 21.5-84 48v24h168v-24c0-26.5-43.5-48-84-48z",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 420h108v24H312z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 36H36C16.1 36 0 52.1 0 72v384c0 19.9 16.1 36 36 36h456c19.9 0 36-16.1 36-36V72c0-19.9-16.1-36-36-36zm-12 408H48V84h432z",
    fill: "#f4b400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 36H36C16.1 36 0 52.1 0 72v3c0-19.9 16.1-36 36-36h456c19.9 0 36 16.1 36 36v-3c0-19.9-16.1-36-36-36z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 489H36c-19.9 0-36-16.1-36-36v3c0 19.9 16.1 36 36 36h456c19.9 0 36-16.1 36-36v-3c0 19.9-16.1 36-36 36z",
    fill: "#bf360c",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8 444h-108l48 48h107.9z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 81h432v3H48z",
    fill: "#263238",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 444h432v3H48z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 36H36C16.1 36 0 52.1 0 72v384c0 19.9 16.1 36 36 36h456c19.9 0 36-16.1 36-36V72c0-19.9-16.1-36-36-36z",
    fill: "url(#b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleClassroom);
export default __webpack_public_path__ + "static/media/google-classroom.a6628862a09baad295f852deebe20991.svg";
export { ForwardRef as ReactComponent };